import { render, staticRenderFns } from "./Shippers.vue?vue&type=template&id=918e85fc&scoped=true&"
import script from "./Shippers.vue?vue&type=script&lang=js&"
export * from "./Shippers.vue?vue&type=script&lang=js&"
import style0 from "./Shippers.vue?vue&type=style&index=0&id=918e85fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918e85fc",
  null
  
)

export default component.exports